// src/observer/bridge.ts
import { wait } from "@latticexyz/common/utils";

// src/debug.ts
import createDebug from "debug";
var debug = createDebug("mud:explorer");

// src/observer/debug.ts
var debug2 = debug.extend("observer");

// src/observer/bridge.ts
"use client";
function wrapMessage(data) {
  return { mud: "explorer/observer", data };
}
function createBridge({ url, timeout = 1e4 }) {
  const bridge = new Promise((resolve, reject) => {
    const iframe = Array.from(document.querySelectorAll("iframe[data-bridge][src]")).filter((el) => true).find((el) => el.src === url) ?? document.createElement("iframe");
    if (iframe.dataset.bridge === "ready") {
      debug2("reusing observer iframe", iframe.src);
      return resolve(iframe);
    }
    Promise.race([
      new Promise((resolve2, reject2) => {
        iframe.addEventListener("load", () => resolve2(), { once: true });
        iframe.addEventListener("error", (error) => reject2(error), { once: true });
      }),
      wait(timeout).then(() => {
        throw new Error("Timed out waiting for observer iframe to load.");
      })
    ]).then(
      () => {
        debug2("observer iframe ready", iframe.src);
        iframe.dataset.bridge = "ready";
        resolve(iframe);
      },
      (error) => {
        debug2("observer iframe error", error);
        iframe.remove();
        reject(error);
      }
    );
    if (iframe.dataset.bridge !== "loading") {
      iframe.tabIndex = -1;
      iframe.ariaHidden = "true";
      iframe.style.position = "absolute";
      iframe.style.border = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.dataset.bridge = "loading";
      iframe.src = url;
      debug2("mounting observer iframe", url);
      parent.document.body.appendChild(iframe);
    }
  });
  return (type, data) => {
    debug2("got message for bridge", type, data);
    bridge.then(
      (iframe) => {
        debug2("posting message to bridge", type, data);
        const message = wrapMessage({ type, time: Date.now(), ...data });
        iframe.contentWindow.postMessage(message, "*");
      },
      (error) => debug2("could not deliver message", type, data, error)
    );
  };
}

// src/observer/decorator.ts
import { getAbiItem } from "viem";
import { waitForTransactionReceipt, writeContract } from "viem/actions";
import { formatAbiItem, getAction } from "viem/utils";
var writeCounter = 0;
function observer({ explorerUrl = "http://localhost:13690", waitForTransaction } = {}) {
  const emit = createBridge({ url: `${explorerUrl}/internal/observer-relay` });
  return (client) => ({
    async writeContract(args) {
      const writeId = `${client.uid}-${++writeCounter}`;
      const write = getAction(client, writeContract, "writeContract")(args);
      const functionAbiItem = getAbiItem({
        abi: args.abi,
        name: args.functionName,
        args: args.args
      });
      emit("write", {
        writeId,
        address: args.address,
        from: client.account.address,
        functionSignature: formatAbiItem(functionAbiItem),
        args: args.args ?? [],
        value: args.value
      });
      Promise.allSettled([write]).then(([result]) => {
        emit("write:result", { ...result, writeId });
      });
      write.then((hash) => {
        const receipt = getAction(client, waitForTransactionReceipt, "waitForTransactionReceipt")({ hash });
        emit("waitForTransactionReceipt", { writeId, hash });
        Promise.allSettled([receipt]).then(([result]) => {
          emit("waitForTransactionReceipt:result", { ...result, writeId });
        });
      });
      if (waitForTransaction) {
        write.then((hash) => {
          const receipt = waitForTransaction(hash);
          emit("waitForTransaction", { writeId });
          Promise.allSettled([receipt]).then(([result]) => {
            emit("waitForTransaction:result", { ...result, writeId });
          });
        });
      }
      return write;
    }
  });
}
export {
  createBridge,
  observer
};
//# sourceMappingURL=observer.js.map